<template>
    <SideFormSection>
        <template #title>Seat Settings</template>
        <template #subtitle>
            Service type and number of seats settings.
        </template>
        <template #rawContent>
            <Card
                title="Seat Settings"
                iconName="users"
            >
                <template #content>
                    <Alert
                        type="info"
                        title="NOTE:"
                    >
                        This setting can only be adjusted when creating a new
                        service.
                    </Alert>
                    <ServiceTypeAndAttendeesForm :service="service" />
                </template>
                <template #actions>
                    <Button
                        disabled
                        iconName="save"
                        color="dark"
                    >
                        Save
                    </Button>
                </template>
            </Card>
        </template>
    </SideFormSection>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import SideFormSection from '@/Shared/Component/SideFormSection.vue'
    import Card from '@/Shared/Component/Card.vue'
    import Service from '@/App/Service/Entity/Service'
    import Button from '@/Shared/Component/Button.vue'
    import ServiceTypeAndAttendeesForm from '@/App/Service/Component/Service/ServiceTypeAndAttendeesForm.vue'
    import Alert from '@/Shared/Component/Alert.vue'

    const props = defineProps({
        service: {
            type: Object as PropType<Service>,
            required: true,
        },
    })
</script>
